const getAPI = async () => {
  if (typeof window === "undefined") {
    return
  }

  if (window.__ucCmp && await window.__ucCmp.isInitialized()) {
    return window.__ucCmp
  }

  return new Promise(resolve => {
    window.addEventListener("UC_UI_INITIALIZED", async () => {
      if (await window.__ucCmp.isInitialized()) {
        resolve(window.__ucCmp)
      }
    })
  })
}

export const getServiceByName = async name => {
  const API = await getAPI()
  if (!API) {
    return
  }

  const { services } = await API.getConsentDetails()
  for (const service in services) {
    if (services[service].name === name) {
      return {
        id: service,
        service: services[service]
      }
    }
  }

  return null
}

export const hasConsent = async name => {
  return (await getServiceByName(name))?.service?.consent?.given || false
}

export const updateConsent = async (name, status) => {
  const API = await getAPI()
  if (!API) {
    return
  }

  const service = await getServiceByName(name)
  if (!service) {
    return
  }

  await API.updateServicesConsents([{id: service.id, consent: status}])
  window.__ucCmp.saveConsents()
}

export const showSettings = async () => {
  const API = await getAPI()
  if (!API) {
    return
  }

  return API.showSecondLayer()
}